export default __webpack_public_path__ + "static/media/ESG_Mobile.b45c3b35.gif";